// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__hGRT5","col":"CardReaderDesc_col__3IHxa","label":"CardReaderDesc_label__duJB9"};